export const createEmptySolutionForm = () => ({
  id: Date.now() + Math.floor(Math.random() * 1000),
  title_en: "",
  author: "",
  author_id: "",
  published_at: "",
  status: "Unverified",
  contributors: [],

  title: "",
  aim: "",
  website: "",
  location_country: "",
  lead_org_name: "",

  notes: "",
  source: "",
  story: "",
  impacts: "",
  beneficiaries: "",
  beneficiaries_details: "",
  lead_org_country: "",
  lead_org_region: "",
  lead_org_town: "",
  lead_org_other: "",
  location_region: "",
  location_town: "",
  other_orgs: "",

  api: false,
  geospatial: false,
  lead_women: false,
  innovation_digital: false,

  lead_org_type: null,
  changes: null,
  continuation: null,

  challenges: [],
  rdd: [],
  priorities: [],
  barriers: [],
  biodiversity: [],
  capitals: [],
  innovation_social: [],
  climatechange_mitigation: [],
  categories_agrifood: [],
  categories_energy: [],
  categories_mobility: [],
  categories_tourism: [],
  climatechange_adaptation: [],
  development_approach: [],
  enbling_conditions: [],
  founding: [],
  geographical_featues: [],
  innovation_culture: [],
  innovation_digital_chars: [],
  innovation_financial: [],
  innovation_technical: [],
  local_services: [],
  replicability: [],
  social_justice: [],
  stakeholders_partecipation: [],
  territorial_features: [],
  territorial_implementation_scale: [],
});

// These fields are stored as integers in FastAPI/Cassandra, even if the form
// lets the user interact with them as strings or empty values.
const INTEGER_FIELDS = new Set(["id", "lead_org_type", "changes", "continuation"]);

const INTEGER_LIST_FIELDS = new Set([
  "challenges",
  "rdd",
  "priorities",
  "barriers",
  "biodiversity",
  "capitals",
  "innovation_social",
  "climatechange_mitigation",
  "categories_agrifood",
  "categories_energy",
  "categories_mobility",
  "categories_tourism",
  "climatechange_adaptation",
  "development_approach",
  "enbling_conditions",
  "founding",
  "geographical_featues",
  "innovation_culture",
  "innovation_digital_chars",
  "innovation_financial",
  "innovation_technical",
  "local_services",
  "replicability",
  "social_justice",
  "stakeholders_partecipation",
  "territorial_features",
  "territorial_implementation_scale",
]);

const toInteger = (value) => {
  if (value === "" || value === null || value === undefined) {
    return null;
  }

  const parsedValue = Number(value);
  return Number.isNaN(parsedValue) ? null : parsedValue;
};

const toIntegerList = (value) => {
  if (Array.isArray(value)) {
    return value
      .map((item) => toInteger(item))
      .filter((item) => item !== null);
  }

  const parsedValue = toInteger(value);
  return parsedValue === null ? [] : [parsedValue];
};

export const normalizeSolutionFormPayload = (form) => {
  // Keep the form shape flexible in the UI, but always send backend-safe types
  // from one shared place so create and update behave the same way.
  const normalized = { ...form };

  INTEGER_FIELDS.forEach((fieldName) => {
    normalized[fieldName] = toInteger(normalized[fieldName]);
  });

  INTEGER_LIST_FIELDS.forEach((fieldName) => {
    normalized[fieldName] = toIntegerList(normalized[fieldName]);
  });

  normalized.api = Boolean(normalized.api);
  normalized.geospatial = Boolean(normalized.geospatial);
  normalized.lead_women = Boolean(normalized.lead_women);
  normalized.innovation_digital = Boolean(normalized.innovation_digital);

  return normalized;
};